import React from "react";
import { FormButtons } from "@emisgroup/ui-form";

interface CustomFormButtonProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
  /**
   * Custom style for current form button
   */
  className?: string;
  /**
   * Custom Id for form element
   */
  id?: string;
}

/**
 * Responsible for rendering the form button
 * @returns form button and its child elements
 */
export const UIFormButton: React.FC<CustomFormButtonProps> = (props: CustomFormButtonProps) => {
  const { children } = props;
  return (
    <FormButtons
      {...props}
    >
      {children}
    </FormButtons>
  );
};
